import { dataService } from './data_service';

class RowFilterService {
  constructor() {
    this._columnIndexes = [1, 2, 0];

    // Structure for `_selectedFilters` looks like this
    // this._selectedFilters = {
    //   1: ['Endoscopic Ultrasound', 'Surgical Fiber Endoscope'],
    //   2: []
    // }
    this._selectedFilters = {};
  }

  get selectedFilters() {
    return this._selectedFilters;
  }

  get selectedFiltersCount() {
    let result = 0;

    for (let index in this._selectedFilters) {
      if (this._selectedFilters[index]) {
        result += this._selectedFilters[index].filter(Boolean).length;
      }
    }

    return result;
  }

  createFilters() {
    this.updateFilters(dataService.aggregateRowsByColumns(this._columnIndexes));
  }

  createFiltersHTML(columnIndex, value) {
    let selected = this.isFilterSelected(columnIndex, value);
    return `<li data-controller="filter" data-action="click->filter#toggle" data-filter-column-index="${columnIndex}"><span class="icon ${
      selected ? 'selected' : ''
    }"></span><span>${value}</span></li>`;
  }

  updateFiltersCount() {
    $('span.counter.row-filters').text(this.selectedFiltersCount);
  }

  updateFilters(data, startIndex) {
    for (let columnIndex of this._columnIndexes) {
      let index = this._columnIndexes.indexOf(columnIndex);

      if (typeof startIndex == 'undefined' || index >= startIndex) {
        let html = '';
        let htmlElement = document.querySelector(
          `.columns .column:nth-child(${index + 1})`,
        );

        if (htmlElement == null) {
          html = '<div class="column">';
        }

        let active = this.allowedToBeSelected(columnIndex);

        html += `<div class="column-header ${
          active ? 'active' : 'inactive'
        }">${dataService.headerOfColumn(columnIndex)}</div>`;
        html += `<div class="items ${active ? '' : 'inactive'}"><ul>`;

        for (let value of data[columnIndex]) {
          html += this.createFiltersHTML(columnIndex, value);
        }

        html += '</ul></div>';

        if (htmlElement == null) {
          html += '</div>'; // Close .column div
          document
            .querySelector('.columns')
            .insertAdjacentHTML('beforeend', html);
        } else {
          // Update column HTML
          htmlElement.innerHTML = html;
        }
      }
    }

    this.updateFiltersCount();
  }

  isFilterSelected(columnIndex, value) {
    return (
      this._selectedFilters[columnIndex] &&
      this._selectedFilters[columnIndex].includes(value)
    );
  }

  updateFilter(columnIndex, value, element) {
    columnIndex = parseInt(columnIndex);

    if (!this.isAnyParentFilterSelected(columnIndex)) {
      return;
    }

    this._selectedFilters[columnIndex] =
      this._selectedFilters[columnIndex] || [];

    if (this._selectedFilters[columnIndex].includes(value)) {
      this._selectedFilters[columnIndex].splice(
        this._selectedFilters[columnIndex].indexOf(value),
        1,
      );
    } else {
      this._selectedFilters[columnIndex].push(value);
    }

    let index = this._columnIndexes.indexOf(columnIndex);

    // Clear states of all child filters
    for (var i = index + 1; i < this._columnIndexes.length; i++) {
      this._selectedFilters[this._columnIndexes[i]] = [];
    }

    // Collect and update filters
    let filterData = [];
    let data = dataService.rowsWithoutHeader;

    for (let columnIndex of this._columnIndexes) {
      filterData[columnIndex] = dataService.aggregateRowsByColumn(
        columnIndex,
        data,
      );
      data = dataService.filter(
        data,
        columnIndex,
        this._selectedFilters[columnIndex],
      );
    }

    if (element) {
      element.parentElement.querySelector('.icon').classList.toggle('selected');
    }

    this.updateFilters(filterData, index + 1);
  }

  allowedToBeSelected(columnIndex) {
    let index = this._columnIndexes.indexOf(columnIndex);

    if (index == 0) {
      // Always true for first / most left column
      return true;
    }

    if (Object.keys(this._selectedFilters).length == 0) {
      // No filter selected at all
      return false;
    }

    // Check for selected filters one column further left / previous column
    return this._selectedFilters[this._columnIndexes[index - 1]].length > 0;
  }

  isAnyParentFilterSelected(columnIndex) {
    let index = this._columnIndexes.indexOf(columnIndex);

    if (index == 0) {
      // Always true for first / most left column
      return true;
    }

    if (Object.keys(this._selectedFilters).length == 0) {
      // No filter selected at all
      return false;
    }

    return this._selectedFilters[this._columnIndexes[index - 1]].length > 0;
  }

  applySelectedFiltersToData() {
    let result = dataService.rowsWithoutHeader;

    for (let columnIndex of this._columnIndexes) {
      result = dataService.filter(
        result,
        columnIndex,
        this._selectedFilters[columnIndex],
      );
    }

    return result;
  }

  clearAllSelectedFilters() {
    this._selectedFilters = {};
  }
}

export let rowFilterService = new RowFilterService();
